// Shared vocabulary for the chief-of-staff onboarding branch: the profile
// the previews render from, and the chat platforms the connect step names.

export type ChatProvider = "slack" | "gchat" | "teams";

export type CosProfile = {
  name: string;
  website: string;
  companyName: string;
  // IANA zone, detected from the browser and editable.
  timeZone: string;
  // "HH:MM" 24h local to timeZone; drives the daily-briefing heartbeat hour.
  // Both fields travel to the brain as setup inputs on PUT /internal/posture
  // ({ posture: "chief-of-staff", setup: { timeZone, briefingTime } }).
  briefingTime: string;
};

export const CHAT_LABELS: Record<ChatProvider, string> = {
  slack: "Slack",
  gchat: "Google Chat",
  teams: "Microsoft Teams",
};

export function firstName(name: string): string {
  return name.trim().split(/\s+/)[0] ?? "";
}

export function initialOf(name: string): string {
  const first = firstName(name);
  return first ? first[0].toUpperCase() : "?";
}

// "08:00" -> "8:00 AM"
export function formatDayStart(briefingTime: string): string {
  const [h, m] = briefingTime.split(":").map(Number);
  if (Number.isNaN(h)) return briefingTime;
  const suffix = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}:${String(Number.isNaN(m) ? 0 : m).padStart(2, "0")} ${suffix}`;
}
